// src/store/surveyInvite/surveyInvite-operations.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { api } from '@utils/api';

type Err = { message?: string; detail?: string };

const NO_RETRY_CFG = { headers: { 'X-Skip-Auth-Retry': '1' } };

export const notifyShownOperation = createAsyncThunk<
  { invite_id?: number; status?: string; last_channel_sent?: string },
  void,
  { rejectValue: string }
>('surveyInvite/notifyShown', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.post(
      '/survey-invites/notify/sent',
      { source: 'web', response: { modal: 'shown' } },
      NO_RETRY_CFG
    );
    return data;
  } catch (e) {
    const err = e as AxiosError<Err>;
    return rejectWithValue(err.response?.data?.message || err.response?.data?.detail || err.message);
  }
});

export const deferOperation = createAsyncThunk<
  { status: 'postponed'; next_reminder_at?: string },
  void,
  { rejectValue: string }
>('surveyInvite/defer', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.post(
      '/survey-invites/defer',
      { source: 'web' },
      NO_RETRY_CFG
    );
    return data;
  } catch (e) {
    const err = e as AxiosError<Err>;
    return rejectWithValue(err.response?.data?.message || err.response?.data?.detail || err.message);
  }
});

export const acceptOperation = createAsyncThunk<
  { status: 'accepted' },
  void,
  { rejectValue: string }
>('surveyInvite/accept', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.post(
      '/survey-invites/accept',
      { source: 'web' },
      NO_RETRY_CFG
    );
    return data;
  } catch (e) {
    const err = e as AxiosError<Err>;
    return rejectWithValue(err.response?.data?.message || err.response?.data?.detail || err.message);
  }
});
